import { createAction } from '@mews/framework';
import prefix from '../prefix';
import { displayAppLoader } from './refresh';

export const APP_TEARDOWN_STARTED = prefix('APP_TEARDOWN_STARTED');

export const teardown =
    () =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        dispatch(displayAppLoader());
        dispatch(createAction(APP_TEARDOWN_STARTED));

        if (container) {
            const { apiComponent } = container();
            apiComponent.abortCurrentRequests();
        }
    };
